module.exports = require("./factory")("g");



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/gen-css-identifier/index.js
// module id = 1552
// module chunks = 3